/**
 * Betby spor kitabının launch görünümü (SynCode ``customData`` alanı).
 *
 * Kümeler backend'deki `services/syncode.py` (`BETBY_LAYOUTS` / `BETBY_COLORS`)
 * ile **aynı kalmalıdır**: sağlayıcı tanımadığı düzeni/rengi reddetmez,
 * sessizce varsayılana düşer. Panelde görünüp uygulanmayan bir seçenek
 * "seçtiğim tema çalışmıyor" şikâyetinden başka iz bırakmaz — bu yüzden
 * backend geçersiz değeri 400 ile geri çevirir ve liste burada dar tutulur.
 */
export const BETBY_LAYOUTS = [
  { value: 'tile', label: 'Kutulu (tile)' },
  { value: 'sidebar', label: 'Yan menülü (sidebar)' },
  { value: 'classic', label: 'Klasik (classic)' },
];

export const BETBY_COLORS = [
  { value: 'black-green', label: 'Siyah · Yeşil' },
  { value: 'blue-dark', label: 'Mavi · Koyu' },
  { value: 'blue-yellow', label: 'Mavi · Sarı' },
  { value: 'green-dark', label: 'Yeşil · Koyu' },
  { value: 'green-orange', label: 'Yeşil · Turuncu' },
  { value: 'grey-purple', label: 'Gri · Mor' },
  { value: 'lightgreen-dark', label: 'Açık Yeşil · Koyu' },
  { value: 'purple-white', label: 'Mor · Beyaz' },
  { value: 'purple-yellow', label: 'Mor · Sarı' },
  { value: 'red-purple', label: 'Kırmızı · Mor' },
  { value: 'red-white', label: 'Kırmızı · Beyaz' },
  { value: 'turquoise-dark', label: 'Turkuaz · Koyu' },
  { value: 'white-blue', label: 'Beyaz · Mavi' },
  { value: 'yellow-dark', label: 'Sarı · Koyu' },
];

export default BETBY_LAYOUTS;
